import script from "./loginTel.vue?vue&type=script&setup=true&lang=js"
export * from "./loginTel.vue?vue&type=script&setup=true&lang=js"

import "./loginTel.vue?vue&type=style&index=0&id=5abadd14&lang=less"
import "./loginTel.vue?vue&type=style&index=1&id=5abadd14&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5abadd14"]])

export default __exports__